// Стили
import "./style/index.scss"

// Компоненты
import {Section} from "./components/portfolio";
import {CreativeCoalition} from "../../general_components/CreativeCoalition";

export function IndexPage() {
    return (
        <main className="main">
            <div className="max_size">
                <CreativeCoalition>
                    Группа людей,<br/>
                    объединенных ради<br/>
                    творчества
                </CreativeCoalition>

                <p className="center_text">Портфолио наших сотрудников:</p>
                <br/>
                <Section category="3D Арты" first_line={false}/>

                <Section category="2D Арты"/>

                <Section category="Скин-мейкеры"/>

                <Section category="Билдеры"/>

                <Section category="Модельеры"/>

                <Section category="Добытчики"/>

                <div className="line"/>
            </div>
        </main>
    )
}
